import {get,post} from '../utils/request'
import axios from 'axios'

// 课程
// 家长学习课程
export const parentStudy = (params) => get('https://yingde_api.ydassess.com/courses/parents/learn',params)

// 获取补充课程下拉框  家长  教师
export const supplementCourseSelect = (params) => get('https://yingde_api.ydassess.com/courses/public/attrs',params)

// 保存家长、学生、教师的课程心得感悟
export const savePerception = (data) => post('https://yingde_api.ydassess.com/courses/public/feeling',data)

// 创建不同媒体类型课程
export const createCourse = (data) => post('https://yingde_api.ydassess.com/courses/public/new',data)

// 学生、教师、家长、校长根据角色个人补充课程
export const supplementCourse = (params) => get('https://yingde_api.ydassess.com/courses/public/supplement',params)

// 获取学生端/家长端/教师端/校长端个人推荐(基于弱项领域推荐)的课程
export const personRecommend = (params) => get('https://yingde_api.ydassess.com/courses/public/recommended',params)

// 获取学生端/家长端 年级推荐（基于弱项领域推荐）的课程
export const dradeRecommend = (params) => get('https://yingde_api.ydassess.com/courses/public/grade/recommended',params)

// 学生/家长：课程详情
export const courseDetail = (url,params) => get(url,params)

// 获取课程的 field/integration/tags 信息
export const courseAttrs = (params) => get('https://yingde_api.ydassess.com/courses/public/attrs',params)

// 下载HAWA、心理报告
export const filePdf = (data) =>{
    return axios({
        method: "get",
        url:'https://yingde_api.ydassess.com/health/report/downloads',
        params: data,
        responseType: 'blob',
        headers:{
            'Content-Type':"application/json; charset=UTF-8",
            'ticket':'mock-ticket',
            'Tgt':sessionStorage.getItem('TGT'),
            'X-Request-Accesstoken':sessionStorage.getItem('accessToken')
        }
    })
}


// WEBPACK FOOTER //
// ./src/api/parentApi.js